module.exports = __webpack_public_path__ + "img/gplay.2cb94200.png";